//load our custom elements
require("component-leaflet-map");
require("component-responsive-frame");

//get access to Leaflet and the map
var element = document.querySelector("leaflet-map");
var L = element.leaflet;
var map = element.map;
var $ = require("jquery");

var data = require("./map.geo.json");

data.features.forEach(function(feature) {
  feature.properties.white_pop_change = feature.properties.white_pop_change.toFixed(1);
  feature.properties.diversity_change = feature.properties.diversity_change.toFixed(1);
  feature.properties.diversity_2010 = feature.properties.diversity_2010.toFixed(1);
  feature.properties.diversity_2015 = feature.properties.diversity_2015.toFixed(1);
  feature.properties.population = commafy(feature.properties.population);
  feature.properties.White = (feature.properties.White *100).toFixed(1);
  feature.properties.Black = (feature.properties.Black *100).toFixed(1);
  feature.properties.NA_AN = (feature.properties.NA_AN *100).toFixed(1);
  feature.properties.Asian = (feature.properties.Asian *100).toFixed(1);
  feature.properties.PI_NH = (feature.properties.PI_NH *100).toFixed(1);
  feature.properties.other = (feature.properties.other *100).toFixed(1);
  feature.properties.Hispanic = (feature.properties.Hispanic *100).toFixed(1);
})

var ich = require("icanhaz");
var templateFile = require("./_popup.html");
ich.addTemplate("popup", templateFile);

function commafy( num ) {
 num = num.toString();
 if (!num) return;
 if (num.length >= 4) {
   num = num.replace(/(\d)(?=(\d{3})+$)/g, '$1,');
 }
 return num;
}
function highlightFeature(e) {
    var layer = e.target;

    layer.setStyle({
        weight: 4,
        color: '#666',
        fillOpacity: 0.5
    });

    if (!L.Browser.ie && !L.Browser.opera) {
        layer.bringToFront();
    }
}
function resetHighlight(e) {
    geojson.resetStyle(e.target);
}
var onEachFeature = function(feature, layer) {
  function click(e) {
  var container = $(".mobile-popup");
   container.html(ich.popup(feature.properties));
};


  // if (feature.properties) {
  //   layer.bindPopup(ich.popup(feature.properties))
  // };
  layer.on({
    mouseover: highlightFeature,
    mouseout: resetHighlight,
    click: click
});
};

 map.scrollWheelZoom.disable();


 var getColor = function(area) {
  if (area > -1) {
    return "#cbc9e2";
  }
  if (area > -2) {
    return "#9e9ac8";
  }
  if (area > -3) {
    return "#756bb1";
  }
  if (area > -4) {
    return "#54278f";
  }

  return "transparent";
}

var geojson = L.geoJson(data, {
  style: function(feature) {
    console.log(feature.properties.NAME,feature.properties.white_pop_change);
      return {
        fillColor: getColor(feature.properties.white_pop_change),
        weight: 1,
        opacity: 1,
        color: "white",
        fillOpacity: 0.8
      }
  },
onEachFeature: onEachFeature
}).addTo(map);
var topPane = map._createPane('leaflet-top-pane', map.getPanes().mapPane);
var topLayer = L.tileLayer('http://{s}.basemaps.cartocdn.com/light_only_labels/{z}/{x}/{y}.png').addTo(map);
topPane.appendChild(topLayer.getContainer());
topLayer.setZIndex(6);

map.fitBounds(geojson.getBounds());
//
// console.log(map.getCenter());

map.setView([47.409, -121.233], 7);
